export const styledSelectInputContainer = _ref => {
  let {
    layout
  } = _ref;
  return {
    display: layout === 'horizontal' ? 'inline-flex' : 'flex',
    flexFlow: layout === 'horizontal' ? 'row' : 'column wrap',
    alignItems: layout === 'horizontal' ? 'center' : '',
    justifyContent: 'flex-start',
    width: '100%',
    gap: layout === 'horizontal' ? '' : '4px',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale'
  };
};